import {useState, useEffect, useCallback, useMemo} from 'react';
import {getAdminDashboardByPeriods} from './business/dashboardBusiness';
import {useHistory} from 'react-router-dom';
import {getPathByMenuId} from '../../stores/business/appBusiness';
import {EMenuId} from '../../const/dataEnum';
import {useDispatch} from 'react-redux';
import DashboardCardLayout from '../../components/DashboardCardLayout';
import {formatPeriodDate} from '../../lib/dateTimesHelpers';
import {statusTranslator} from '../../lib/utilities';

const AdminDashboardInfo = ({periode, currentPeriod}) => {
  const [isLoading, setIsLoading]=useState(false);
  const [data, setData] = useState({
    activeEmployee: 0,
    completeAssignmentTeam:0,
    totalTeam: 0,
    consolidationAll: 0,
  });

  const dispatch = useDispatch();


  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const result = await dispatch(getAdminDashboardByPeriods(currentPeriod));
        setData({
          ...result,
          consolidationAll: statusTranslator(result.consolidationAll),
        });
      } catch (error) {
        console.error('fetch API not ready yet', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [currentPeriod, dispatch]);


  const history = useHistory();
  const handleClickGoToPage = useCallback((page) => {
    const path = getPathByMenuId(page);
    if (path) {
      history.push(path);
    }
  }, [history]);

  const cardContents = useMemo(() => [
    {
      dataFormated: `${data?.activeEmployee}`,
      heading: 'Active Employee',
      actions: [
        {
          label: 'Manage Employee',
          onClick: () => handleClickGoToPage(EMenuId.MANAGE_EMPLOYEE),
        },
      ],
    },
    {
      dataFormated: `${data?.assignedEmployee} / ${data?.totalEmployee}`,
      heading: 'Assignment',
      actions: [
        {
          label: 'Manage Assignment',
          onClick: () => handleClickGoToPage(EMenuId.MANAGE_ASSIGNMENT),
        },
      ],
    },
    {
      dataFormated: `${data?.consolidationAll}`,
      heading: 'Consolidation',
      actions: [
        {
          label: 'Go to consolidation',
          onClick: () => handleClickGoToPage(EMenuId.CONSOLIDATION),
        },
      ],
    },
    {
      dataFormated: null,
      heading: 'Question',
      actions: [
        {
          label: 'Manage Question',
          onClick: () => handleClickGoToPage(EMenuId.MANAGE_QUESTION),
        },
      ],
    },
    {
      dataFormated: `${formatPeriodDate(periode)}`,
      heading: 'Active Review Period',
      actions: [
        {
          label: 'Manage Period',
          onClick: () => handleClickGoToPage(EMenuId.MANAGE_PERIODS),
        },
      ],
    },
    {
      dataFormated: `${data?.totalTeam}`,
      heading: 'Total Team',
      actions: [
        {
          label: 'Team Assignment',
          onClick: () => handleClickGoToPage(EMenuId.TEAM_ASSIGNMENT),
        },
      ],
    },
  ], [data, periode, handleClickGoToPage]);

  return (
    <DashboardCardLayout
      className={'dashboard-info'}
      cardClassName={'dashboard-card'}
      row={2}
      col={3}
      content={cardContents}
      loading={isLoading}
    />
  );
};

export default AdminDashboardInfo;
